import { createRef } from 'react'
import { connect } from 'react-redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'

import autocompleteFilter from '../../utils/autocompleteFilter'
import { ssrIsNotLuggageSSR } from '../../utils/ssrs'

import SsrAutoComplete from '../../components/SsrAutoComplete'

interface AddSSRPropsInterface {
  onConfirm: Function
  name: string
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: AddSSRPropsInterface
) => {
  const options = state.ssrs.allIds
    .map((ssr: string) => state.ssrs.byId[ssr])
    .filter(ssrIsNotLuggageSSR)

  return {
    name: props.name,
    onConfirm: props.onConfirm,
    options,
    quoteIsConfirmed: false,
    elementRef: createRef(),
    filterMethod: autocompleteFilter,
    autocomplete: 'off',
  }
}

export default connect(mapStateToProps)(SsrAutoComplete)
